import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from './i18n/en';

// Force English language only
const i18nProvider = polyglotI18nProvider(
    () => englishMessages, // Always return English messages
    'en' // Always use English locale
);

export default i18nProvider; 